(function($) {

    const init = () => {

        initFields();

        /* nav links */
        const navLinks = document.querySelectorAll('.enrollment--nav a');
        navLinks.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                const step = link.dataset.step;
                if(step){
                    jumpToStep(step);
                }
            });
        });

        /* buttons */
        const nextButtons = document.querySelectorAll('.btn--step--next');
        nextButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const thisStep = e.currentTarget.dataset.step;
                if (thisStep) {
                    validateStep(thisStep);
                }
            });
        });

        const prevButtons = document.querySelectorAll('.btn--step--prev');
        prevButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const targetStep = e.currentTarget.dataset.step;
                if(targetStep){
                    jumpToStep(targetStep);
                }
            });
        });

        const reviewButton = document.querySelector('.btn--step--review');
        reviewButton.addEventListener('click', (e) => {
            e.preventDefault();
            jumpToStep(1);
        });
        
        const submitButton = document.querySelector('.btn--step--submit');
        submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            const thisStep = e.currentTarget.dataset.step;
            if (thisStep) {
                validateStep(thisStep);
            }
        });
    }

    const loadStates = () => {
        return fetch(window.location.origin + "/wp-content/themes/yuviwel/assets/dist/util/state-dropdown.json")
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            let stateSet = new Set(data);
            buildDropdown("patient_state", stateSet);
            buildDropdown("prescriber_state", stateSet);
        });
    }

    const loadLanguages = () => {
        return fetch(window.location.origin + "/wp-content/themes/yuviwel/assets/dist/util/language-dropdown.json")
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            let languageSet = new Set(data);
            buildDropdown("primary_language", languageSet);
        });
    }

    const buildDropdown = (dropdownTargetID,inputSet) => {
        let dropDownTargetEl = document.getElementById(dropdownTargetID);
        for (let lineItem of inputSet) {
            var opt = document.createElement("option");
            opt.value = lineItem;
            opt.innerHTML = lineItem;
            dropDownTargetEl.appendChild(opt);
        }
    }

    const initFields = async () => {

        /* DROPDOWNS */
        await Promise.all([loadStates(), loadLanguages()]);

        /* DATE PICKER */
        YuviwelDatePicker.init();

        /* SELECT PICKER */
        YuviwelSelect.init();

        /* INSURANCE TOGGLE */
        const insuranceRadios = document.querySelectorAll(
            'input[name="rb_has_insurance"]'
        );

        insuranceRadios.forEach((radio) => {
            radio.addEventListener('change', (event) => {
                const hasInsurance = event.target.value === 'true';

                if (hasInsurance) {
                    enableInsuranceFields(true);
                } else {
                    enableInsuranceFields(false);
                }
            });
        });


        /* FILE UPLOADS */

        //convert files to base 64

        /* INSURANCE CARD FRONT */
        const rx_insurance_card_front_uploader = document.getElementById("patient_insurance_card_front");
        rx_insurance_card_front_uploader.addEventListener("change", (event) => {
        const files = event.target.files;
        const file = files[0];
        const readerFront = new FileReader();
        readerFront.addEventListener(
            "load",
            () => {
                // convert image file to base64 string and insert into hidden field
                var result = JSON.stringify(readerFront.result);
                result = result.slice(1, -1);
                document.getElementById('patient_insurance_card_front_base64').value = result;
            },
            false
        );
        readerFront.readAsDataURL(file);

            readerFront.addEventListener("progress", (event) => {
                if (event.loaded && event.total) {
                    const percent = (event.loaded / event.total) * 100;
                    const patient_insurance_card_front_uploader_label = document.querySelector('label[for="patient_insurance_card_front"]');
                    // patient_insurance_card_front_uploader_label.style.background = "linear-gradient(to right, #fff 50%, #eff3e6 50.1%)";
                    // patient_insurance_card_front_uploader_label.style.backgroundSize = "200%";
                    // patient_insurance_card_front_uploader_label.style.backgroundPosition = "-" + Math.round(percent) + "%";

                    if (percent === 100) {
                        //display file name when upload is complete.
                        patient_insurance_card_front_uploader_label.innerHTML = file.name;
                    }
                }
            });
        });


        /* INSURANCE CARD BACK */
        const rx_insurance_card_back_uploader = document.getElementById("patient_insurance_card_back");
        rx_insurance_card_back_uploader.addEventListener("change", (event) => {
        const files = event.target.files;
        const file = files[0];
        const readerBack = new FileReader();
        readerBack.addEventListener(
            "load",
            () => {
                // convert image file to base64 string and insert into hidden field
                var result = JSON.stringify(readerBack.result);
                result = result.slice(1, -1);
                document.getElementById('patient_insurance_card_back_base64').value = result;
            },
            false
        );
        readerBack.readAsDataURL(file);

            readerBack.addEventListener("progress", (event) => {
                if (event.loaded && event.total) {
                    const percent = (event.loaded / event.total) * 100;
                    const patient_insurance_card_back_uploader_label = document.querySelector('label[for="patient_insurance_card_back"]');

                    if (percent === 100) {
                        //display file name when upload is complete.
                        patient_insurance_card_back_uploader_label.innerHTML = file.name;
                    }
                }
            });
        });


        /* ADDITIONAL DOCS ================================ */
        const additional_doc_uploader = document.getElementById("additional_doc");
        if(additional_doc_uploader && typeof(additional_doc_uploader)!=="undefined"){
            additional_doc_uploader.addEventListener("change", (event) => {
                const files = event.target.files;
                const fileNames = [];
                for(let f=0;f<files.length;f++){
                    fileNames.push(files[f].name);
                }
                const additional_doc_uploader_label = document.querySelector('label[for="additional_doc"]');
                additional_doc_uploader_label.innerHTML = fileNames.join(', ');

                /* base64 */
                
                const $fileContainer = document.getElementById('additional_doc_files');
                console.log("FC: " + $fileContainer);
                let fileIndex = 0;

                //remove inputs
                const inputs = $fileContainer.querySelectorAll('input');
                inputs.forEach(input => input.remove());


                Array.from(files).forEach(file => {
                    const reader = new FileReader();
                    reader.onload = function(e) {
                    //const base64WithMime = e.target.result;
                    //console.log(`Base64 for ${file.name}:`, base64WithMime);

                    var result = JSON.stringify(e.target.result);
                    result = result.slice(1, -1);
                    const inputType = 'hidden'; 

                    const input_file = document.createElement('input');
                    input_file.type = inputType;
                    input_file.name = `Attachments[${fileIndex}][file]`;
                    input_file.value = result;

                    const input_file_type = document.createElement('input');
                    input_file_type.type = inputType;
                    input_file_type.name = `Attachments[${fileIndex}][FileType]`;
                    input_file_type.value = 'Application/PDF';

                    const input_doc_type = document.createElement('input');
                    input_doc_type.type = inputType;
                    input_doc_type.name = `Attachments[${fileIndex}][DocumentType]`;
                    input_doc_type.value = 'Attachment';

                    //base64WithMime = JSON.stringify(base64WithMime);
                    //base64WithMime = base64WithMime.slice(1, -1);
                    console.log(input_doc_type.name);
                    $fileContainer.appendChild(input_file);
                    $fileContainer.appendChild(input_file_type);
                    $fileContainer.appendChild(input_doc_type);
                    fileIndex++;    



                    };
                    reader.readAsDataURL(file);
                });
                
            });
        }
        /* ADDITIONAL DOCS end ================================ */


        /* AUTH DATE */
        var today = new Date();
        var day = today.getDate() > 9 ? today.getDate() : "0" + today.getDate(); // format should be "DD" not "D" e.g 09
        var month = today.getMonth() + 1 > 9 ? today.getMonth() + 1 : "0" + (today.getMonth() + 1);
        var year = today.getFullYear();
        let formattedTodayDateString = month.toString() + day.toString() + year.toString();
        const auth_date_input = document.getElementById("auth_date");
        auth_date_input.value = year + "-" + month + "-" + day;
        auth_date_input.dispatchEvent(new Event("change", { bubbles: true }));


        /* PHONE NUMBERS */
        const phones = document.querySelectorAll('input[type="tel"]');
        phones.forEach((phone)=>{
            phone.maxLength = 10;
            phone.addEventListener('input', () => {
                phone.value = phone.value.replace(/\D/g, '');
            });
        });

        /* NPI */
        const npi = document.getElementById('npi');
        npi.maxLength = 10;
        npi.minLength = 10;
        npi.addEventListener('input', () => {
            npi.value = npi.value.replace(/\D/g, '');
        });

        /* ZIPCODES */
        const zips = document.querySelectorAll(".zipcodeField");
        zips.forEach((zip) => {
            zip.pattern='[0-9]*';
            zip.placeholder="XXXXX";
            zip.maxLength = 5;
            zip.minLength = 5;
            zip.addEventListener('input', () => {
                zip.value = zip.value.replace(/\D/g, '');
            });
        });

    }

    const enableInsuranceFields = (enable=true) => {
        const $insuranceFields = document.getElementById('insuranceFields');
        const primaryMedical = document.getElementById('medical_insurance');
        const memberID = document.getElementById('member_id');
        if(enable){
            primaryMedical.setAttribute('required', 'required');
            memberID.setAttribute('required', 'required');
            $insuranceFields.classList.remove('enrollment--form--step--section--hidden');
        }
        else{
            $insuranceFields.classList.add('enrollment--form--step--section--hidden');
            primaryMedical.removeAttribute('required');
            memberID.removeAttribute('required');
        }
    }

    const jumpToStep = (step) => {
        step = Number(step);
        document.getElementById('error_notification').classList.remove('hasError');
        const totalSteps = document.querySelectorAll('.enrollment--form--step').length;
        if(step>totalSteps){
            //reached the end of the form, submit
            submitForm();
            return;
        }

        const $currentStep = document.querySelector('.enrollment--form--step--active');
        const $targetStep = document.getElementById(`enrollment_step_${step}`);
        if($currentStep && $targetStep){
            $currentStep.classList.remove('enrollment--form--step--active');
            $targetStep.classList.add('enrollment--form--step--active');
            

            //update nav
            //active

            const navLinks = document.querySelectorAll(`.enrollment--nav a`);
            navLinks.forEach((navLink) => {
                navLink.classList.remove('active','enabled');
                if(Number(navLink.dataset.step)<step){
                    navLink.classList.add('enabled');
                }
                if(Number(navLink.dataset.step)==step){
                    navLink.classList.add('active');
                }
            });

            const navDots = document.querySelectorAll('.enrollment--nav--dots span');
            navDots.forEach((dot,index)=>{
                const stepIndex = index + 1;
                dot.classList.remove('active','enabled');
                if(stepIndex<Number(step)){
                    dot.classList.add('enabled');
                }
                if(stepIndex==Number(step)){
                    dot.classList.add('active');
                }
            });
            
        }

        document.getElementById('enrollment').scrollIntoView({
            behavior: 'auto',
            block: 'start'
        });

    }


    const validateStep = (step) => {
        
        //console.log('validate step: ' + `enrollment_step_${step}`);
        step = Number(step);
        const $currentStep = document.getElementById(`enrollment_step_${step}`);

        document.getElementById('error_notification').classList.remove('hasError');

        if ($currentStep) {

            let isStepValid = true;

            const fields = $currentStep.querySelectorAll(
                'input[type="text"], input[type="email"], input[type="tel"], input[type="date"], input[type="number"], input[type="radio"], input[type="checkbox"], select'
            );

            fields.forEach((field) => {
                const minLength = field.getAttribute('minlength');
                const failsMinLength = minLength && field.value.length > 0 && field.value.length < Number(minLength);

                if (!field.checkValidity() || failsMinLength) {
                    field.closest('.enrollment--field').classList.add('enrollment--field--invalid');
                    isStepValid = false;
                    console.log(field.id + " is INVALID");
                } else {
                    field.closest('.enrollment--field').classList.remove('enrollment--field--invalid');
                }
            });

            /* TESTING */
            //isStepValid = true;

            if (!isStepValid) {
                $currentStep.classList.add('invalid');
                $currentStep.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            } else {
                $currentStep.classList.remove('invalid');
                //check if last step
                //if not
                jumpToStep(step+1);
            }


        }
    }

    const submitForm = () => {

        //disable buttons
        const $submitBtns = document.getElementById('enrollment_submit');
        $submitBtns.classList.add('enrollment--form--step--btns--submitting');
        const $form = document.getElementById('enrollment_form');
        var formData = new FormData($form);
        formData.append("action", "submitEnrollment");
        
        fetch(enrollmentVars.ajaxUrl, {
            method: 'POST',
            body: formData,
        })
        .then(res => {
            if (!res.ok) throw new Error(`Server error: ${res.status}`);
            return res.json();
        })
        .then(response => {
            console.log(response);
            if(response.errorCode){
                const errorContainer = document.getElementById('error_notification');
                if(errorContainer){
                    errorContainer.querySelector('.msg').innerHTML = `
                        Error Code: ${response.errorCode}<br>
                        Error Message: ${response.errorCode}
                        `;
                    errorContainer.classList.add('hasError');
                }
            }
            else{
                window.location.href = '/enrollment/confirmation/';
            }
            $submitBtns.classList.remove('enrollment--form--step--btns--submitting');
        })
        .catch(() => {
            const errorContainer = document.getElementById('error_notification');
            if(errorContainer){
                errorContainer.querySelector('.msg').innerHTML = '';
                errorContainer.classList.add('hasError');
            }
            $submitBtns.classList.remove('enrollment--form--step--btns--submitting');
        });

        

    }

    $(init);

})(jQuery);